import { Sparkles } from "lucide-react";

const VERSION = "2026.06";

// Recent, shipped-and-verifiable changes. Kept honest: only things that
// are live on this build go here.
const CHANGES = [
  {
    date: "June 2026",
    title: "Klair types her answers now",
    body: "Klair's read streams in word by word with a warm, human cadence, so the wait never feels like a freeze. If she has to answer extra quickly, a quiet mark shows near her name.",
  },
  {
    date: "June 2026",
    title: "LinkedIn optimiser",
    body: "Klair rewrites your headline, your about, and your experience from your own words. Anything that drifts from what you actually did gets dropped, and your original stays.",
  },
  {
    date: "June 2026",
    title: "A one-pager worth sending",
    body: "Your shareable one-pager got a cleaner, prouder look, with copy-link and save-as-PDF built in. Still private by default, still yours to revoke.",
  },
  {
    date: "June 2026",
    title: "Clearer dashboard",
    body: "Your home now explains what your pattern and your fit actually mean, in plain words, with a note space that gives you a nudge to start.",
  },
];

/**
 * What's new. A short, honest log of what shipped recently. Nothing here
 * is aspirational; the roadmap of what is coming lives on Upcoming.
 */
export default function WhatsNewScreen() {
  return (
    <div className="max-w-3xl mx-auto px-5 pt-8 pb-24">
      <div className="k-label mb-2 flex items-center gap-2"><Sparkles size={13} /> what's new</div>
      <h1 className="klareet-serif mb-2" style={{ fontSize: "clamp(1.8rem, 4vw, 2.4rem)", lineHeight: 1.1 }} data-testid="whatsnew-title">
        Recently shipped.
      </h1>
      <p className="k-hero-sub mb-6">You are on version <span className="klareet-mono" data-testid="whatsnew-version">{VERSION}</span>.</p>

      <div className="space-y-4" data-testid="whatsnew-list">
        {CHANGES.map((c, i) => (
          <div key={i} className="k-card" data-testid={`whatsnew-item-${i}`}>
            <div className="flex items-center justify-between mb-1">
              <div className="font-semibold" style={{ color: "hsl(var(--klareet-ink))" }}>{c.title}</div>
              <div className="k-quiet !text-xs klareet-mono">{c.date}</div>
            </div>
            <p className="text-sm" style={{ color: "hsl(var(--klareet-ink-soft))", lineHeight: 1.6 }}>{c.body}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
